import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import authService from '../services/auth.service';
import employeeAuthService from '../services/employee-auth.service';

/**
 * Protected route component
 * Checks if user is authenticated and has required role
 * Redirects to login if not authenticated
 * 
 * @param {Object} props
 * @param {string} props.requiredRole - Required role for access (e.g. 'admin')
 * @param {string} props.authType - Type of authentication ('user' or 'employee')
 * @returns {JSX.Element}
 */
const ProtectedRoute = ({ requiredRole, authType = 'user' }) => {
  // Select the appropriate auth service
  const service = authType === 'employee' ? employeeAuthService : authService;
  
  const isAuthenticated = service.isLoggedIn();
  const user = service.getUser();
  
  // Check if user is authenticated
  if (!isAuthenticated) {
    // Redirect to appropriate login page
    return <Navigate to={authType === 'employee' ? "/employee/login" : "/admin/login"} replace />;
  }
  
  // Check if user has required role (if specified)
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return <Outlet />;
};

export default ProtectedRoute;